import { createSelector } from "reselect"
import { get, remove } from "lodash"
import { numberFormatter } from "helpers/formatters/numbers"
import { sortData } from "helpers/contributorsSort"
import { getSelectedGroupSiblings, getSelectedGroupValue, getSelectedContributorCategory, getSelectedGroup } from "."
import { mapContributorsGroupDropDown } from "helpers/compositeSecuritiesDetails"

const columns = {
  group: [{
    id: "name",
    label: "",
    align: "left",
    getter: get,
  }, {
    id: "totalPercentEquity",
    label: "% Equity",
    getter: get,
    formatter: (number) => numberFormatter(number * 100),
  }, {
    id: "value",
    label: "Absolute",
    getter: get,
    formatter: numberFormatter,
  }],
  details: [{
    id: "label",
    label: "",
    align: "left",
    getter: get,
  }, {
    id: "value",
    label: "% Risk",
    getter: get,
    formatter: (number) => numberFormatter(number * 100),
  }],

}

const getDetails = (_, props) => get(props, "details")
const getGroupOrder = (_, props) => get(props, "groupOrder")
const getShowSegment = (_, props) => get(props, "showSegment")
const getSelectedOption = (_, props) => props.selectedOption
const getCurrentGrouping = (_, props) => props.currentGrouping

export const getDropdownItems = createSelector(
  [getSelectedGroupValue, getSelectedGroupSiblings, getDetails, getShowSegment, getGroupOrder],
  (selectedGroup, selectedGroupSiblings, details, showSegment, groupOrder) => {
    if (selectedGroup) {
      return selectedGroupSiblings
    }
    const detailsCopy = [...details]
    if (showSegment) {
      remove(detailsCopy, ({ id }) => id === "total")
    }
    return sortData(detailsCopy, groupOrder)
  },
)

export const getGroupsDropdownColumns = createSelector(
  [getSelectedContributorCategory, getSelectedOption, getSelectedGroup, getCurrentGrouping],
  (selected, selectedOption, selectedGroup, contributorsGrouping) =>
    mapContributorsGroupDropDown(columns, selected, selectedOption, selectedGroup, contributorsGrouping),
)
